module.exports = __webpack_public_path__ + "static/media/pa.4569f5bf.svg";